module["exports"] = [
  "##",
  "#"
];
